module.exports = __webpack_public_path__ + "static/media/videoTrigger.210fe230.webm";